import React, { FunctionComponent, memo, ReactNode } from 'react'

import { InfoTooltip } from '@/atoms/info-tooltip'
import { Space } from '@/styles'

import { CheckboxInput, CheckboxLabel, CheckboxWrapper } from './atoms'

interface Props {
  hasError?: boolean
  onClick: (selected: boolean, value: any) => void
  selected: boolean
  label: string
  name?: string
  value?: string
  disabled?: boolean
  tooltip?: string
  checkboxFlag?: ReactNode
  noWrapLabel?: boolean
  isOption?: boolean
}

const Checkbox: FunctionComponent<Props> = ({
  hasError,
  isOption,
  label,
  onClick,
  selected,
  name,
  value,
  disabled,
  tooltip,
  checkboxFlag,
  noWrapLabel = false,
}) => {
  const handleClick = () => onClick && onClick(selected, value)

  return (
    <CheckboxWrapper onClick={!disabled ? handleClick : undefined} $disabled={disabled} $isOption={isOption}>
      <CheckboxInput
        id={name}
        name={name}
        value={value}
        checked={selected}
        $hasError={hasError}
        onChange={() => null}
        disabled={disabled}
        $isOption={isOption}
      />
      <CheckboxLabel htmlFor={name} $noWrapLabel={noWrapLabel} $isOption={isOption}>
        {label}
      </CheckboxLabel>
      {tooltip && <InfoTooltip tooltipText={tooltip} pl={Space.S8} pt={Space.S4} />}
      {checkboxFlag}
    </CheckboxWrapper>
  )
}

export default memo(Checkbox)
